import { render, staticRenderFns } from "./Factory-order.vue?vue&type=template&id=bd999812&scoped=true&"
import script from "./Factory-order.vue?vue&type=script&lang=js&"
export * from "./Factory-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd999812",
  null
  
)

export default component.exports